import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({ colors }: Theme) => createStyles({
  root: {
    display: 'inline-flex',
    '& svg': {
      fill: colors.uIIconBase,
    },
  },
});

export default styles;
